import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "@revvsales/components";

const JustificationButtons = ({ handleJustification, position, mode }) => (
  <div
    className={`component-justify ${
      mode === "DOCUMENT"
        ? "component-justify-document-position"
        : "component-justify-template-position"
    }`}>
    <Tooltip
      placement="top"
      overlay="Image align left"
      align={{ offset: [0, 2] }}>
      <Button
        data-test="image-align-left-button"
        className={`btn-icon justification-btn ${
          position === "flex-start" ? "selected-justification" : ""
        }`}
        onMouseDown={() => handleJustification("flex-start")}>
        <FontAwesomeIcon
          icon={["fas", "align-left"]}
          className={position === "flex-start" ? "selected-justification" : ""}
        />
      </Button>
    </Tooltip>
    <Tooltip
      placement="top"
      overlay="Image align center"
      align={{ offset: [0, 2] }}>
      <Button
        data-test="image-align-center-button"
        className={`btn-icon justification-btn ${
          position === "center" ? "selected-justification" : ""
        }`}
        onMouseDown={() => handleJustification("center")}>
        <FontAwesomeIcon
          icon={["fas", "align-center"]}
          className={position === "center" ? "selected-justification" : ""}
        />
      </Button>
    </Tooltip>
    <Tooltip
      placement="top"
      overlay="Image align right"
      align={{ offset: [0, 2] }}>
      <Button
        data-test="image-align-right-button"
        className={`btn-icon justification-btn ${
          position === "flex-end" ? "selected-justification" : ""
        }`}
        onMouseDown={() => handleJustification("flex-end")}>
        <FontAwesomeIcon
          icon={["fas", "align-right"]}
          className={position === "flex-end" ? "selected-justification" : ""}
        />
      </Button>
    </Tooltip>
  </div>
);
export default JustificationButtons;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/JustificationButtons.js